import makeRequest from "./makeRequest";
import getRuntimeConstants from "../runtimeConstants";
import getWindow from "../utils/window";

export type ReturnNotesSummary = {
  summary: string;
  disclaimer: string;
};

const getSiteOrigin = () =>
  new URLSearchParams(getWindow()?.location?.search ?? "").get("x-site-origin");

export default async function getReturnNotesSummary() {
  const {
    webContext: { browseLanguage, storeId },
    product: { id: productId },
    returnNotesSummary: {
      returnNotesSummaryApiPath,
      returnNotesSummaryApiTimeout,
    },
  } = getRuntimeConstants();

  const url = returnNotesSummaryApiPath.replace("{id}", productId);
  const browseLocale = browseLanguage?.split("-")?.[0] ?? browseLanguage;

  const params: Record<string, string> = {
    store: storeId,
    lang: browseLocale,
  };

  const siteOrigin = getSiteOrigin();

  if (siteOrigin) {
    params["x-site-origin"] = siteOrigin;
  }

  const mapData = ({ summary, disclaimer }: ReturnNotesSummary) => {
    return { summary, disclaimer };
  };

  const handleErrorReturnValue = (error: Error) => {
    throw error;
  };

  return makeRequest({
    url,
    params,
    timeout: returnNotesSummaryApiTimeout,
    headers: undefined,
    body: undefined,
    requestType: "RETURN_NOTES_API",
    apiName: "Return Notes",
    caller: "Return Notes Summary",
    mapData,
    handleErrorReturnValue,
  });
}
